import { IImpersonationContext } from '../../../../extViewmodels';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../../components-v2/Drawer/AppDrawer';
import { DefaultUniversalAssistantChat } from '../../templates/AssistantChat';
import { TagsDataContextProvider } from './TagsContexts/TagsDataContext';
import { TagsSearchContextProvider } from './TagsContexts/TagsSearchContext';
import { TagsMain } from './TagsMain';

export const TagsContainer = () => {
	return (
		<>
			<TagsSearchContextProvider>
				<TagsDataContextProvider>
					<TagsMain />
				</TagsDataContextProvider>
			</TagsSearchContextProvider>
			<AppDrawer>
				<StickyAppDrawerContent value='ai-assistant'>
					<DefaultUniversalAssistantChat />
				</StickyAppDrawerContent>
				<AppDrawerToolbar>
					<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
				</AppDrawerToolbar>
			</AppDrawer>
		</>
	);
};

export function AdminAccountDetailsTags({ impersonationContext }: { impersonationContext?: IImpersonationContext }) {
	return (
		<TagsSearchContextProvider>
			<TagsDataContextProvider impersonationContext={impersonationContext}>
				<TagsMain isAdminContext impersonationContext={impersonationContext} />
			</TagsDataContextProvider>
		</TagsSearchContextProvider>
	);
}
